import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TEmail(props) {
  const { answers, getJson } = props;
  const categoryId = 1;
  const type = "TEmail";

  useEffect(() => {
    if (answers.length <= 0) {
      getJson({ categoryId, type, answers: [{ selected: "" }] });
    }
  }, [answers, getJson]);

  return <TextField disabled type="text" label="tucorreo@gmail.com" />;
}

TEmail.propTypes = {
  answers: PropTypes.array.isRequired,
  getJson: PropTypes.func,
};
